module.exports = __webpack_public_path__ + "img/smiling_face_with_horns.7c767fc0.gif";